//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.6.3.0 (NJsonSchema v11.5.2.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* eslint-disable */
// ReSharper disable InconsistentNaming

import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

export const API_BASE_URL = new InjectionToken<string>('API_BASE_URL');

export interface IRedirectsRulesClient {
    /**
     * Obtener reglas de redirección
     * @param page (optional) Índice de página (inicia en 0)
     * @param size (optional) Cantidad de elementos por página
     * @param status (optional) Filtra por estado (ACTIVE / INACTIVE)
     * @param q (optional) Término de búsqueda por nombre de regla
     */
    list(storeId: string, page?: number | undefined, size?: number | undefined, status?: Status | undefined, q?: string | undefined): Observable<RedirectsPageDto>;
    /**
     * Crear redirección
     * @return Regla de redirección creada
     */
    create(storeId: string, body: CreateRedirectRuleDto): Observable<RedirectsDto>;
    /**
     * Obtener redireccion
     */
    getById(storeId: string, ruleId: string): Observable<RedirectsDto>;
    /**
     * Actualizar redireccion
     * @return Rule updated
     */
    update(storeId: string, ruleId: string, body: UpdateRedirectsDto): Observable<void>;
    /**
     * Eliminar redireccion
     */
    delete(storeId: string, ruleId: string): Observable<void>;
}

@Injectable({
    providedIn: 'root'
})
export class RedirectsRulesClient implements IRedirectsRulesClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Obtener reglas de redirección
     * @param page (optional) Índice de página (inicia en 0)
     * @param size (optional) Cantidad de elementos por página
     * @param status (optional) Filtra por estado (ACTIVE / INACTIVE)
     * @param q (optional) Término de búsqueda por nombre de regla
     */
    list(storeId: string, page?: number | undefined, size?: number | undefined, status?: Status | undefined, q?: string | undefined): Observable<RedirectsPageDto> {
        let url_ = this.baseUrl + "/hub/search/redirects/store/{storeId}?";
        if (storeId === undefined || storeId === null)
            throw new globalThis.Error("The parameter 'storeId' must be defined.");
        url_ = url_.replace("{storeId}", encodeURIComponent("" + storeId));
        if (page === null)
            throw new globalThis.Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (size === null)
            throw new globalThis.Error("The parameter 'size' cannot be null.");
        else if (size !== undefined)
            url_ += "size=" + encodeURIComponent("" + size) + "&";
        if (status === null)
            throw new globalThis.Error("The parameter 'status' cannot be null.");
        else if (status !== undefined)
            url_ += "status=" + encodeURIComponent("" + status) + "&";
        if (q === null)
            throw new globalThis.Error("The parameter 'q' cannot be null.");
        else if (q !== undefined)
            url_ += "q=" + encodeURIComponent("" + q) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RedirectsPageDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RedirectsPageDto>;
        }));
    }

    protected processList(response: HttpResponseBase): Observable<RedirectsPageDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RedirectsPageDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("No autorizado / Token inv\u00e1lido", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Crear redirección
     * @return Regla de redirección creada
     */
    create(storeId: string, body: CreateRedirectRuleDto): Observable<RedirectsDto> {
        let url_ = this.baseUrl + "/hub/search/redirects/store/{storeId}";
        if (storeId === undefined || storeId === null)
            throw new globalThis.Error("The parameter 'storeId' must be defined.");
        url_ = url_.replace("{storeId}", encodeURIComponent("" + storeId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RedirectsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RedirectsDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<RedirectsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = RedirectsDto.fromJS(resultData201);
            return _observableOf(result201);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("No autorizado / Token inv\u00e1lido", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Obtener redireccion
     */
    getById(storeId: string, ruleId: string): Observable<RedirectsDto> {
        let url_ = this.baseUrl + "/hub/search/redirects/store/{storeId}/{ruleId}";
        if (storeId === undefined || storeId === null)
            throw new globalThis.Error("The parameter 'storeId' must be defined.");
        url_ = url_.replace("{storeId}", encodeURIComponent("" + storeId));
        if (ruleId === undefined || ruleId === null)
            throw new globalThis.Error("The parameter 'ruleId' must be defined.");
        url_ = url_.replace("{ruleId}", encodeURIComponent("" + ruleId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RedirectsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RedirectsDto>;
        }));
    }

    protected processGetById(response: HttpResponseBase): Observable<RedirectsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RedirectsDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("No autorizado / Token inv\u00e1lido", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Actualizar redireccion
     * @return Rule updated
     */
    update(storeId: string, ruleId: string, body: UpdateRedirectsDto): Observable<void> {
        let url_ = this.baseUrl + "/hub/search/redirects/store/{storeId}/{ruleId}";
        if (storeId === undefined || storeId === null)
            throw new globalThis.Error("The parameter 'storeId' must be defined.");
        url_ = url_.replace("{storeId}", encodeURIComponent("" + storeId));
        if (ruleId === undefined || ruleId === null)
            throw new globalThis.Error("The parameter 'ruleId' must be defined.");
        url_ = url_.replace("{ruleId}", encodeURIComponent("" + ruleId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Solicitud incorrecta", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("No autorizado / Token inv\u00e1lido", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Regla no encontrada", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Eliminar redireccion
     */
    delete(storeId: string, ruleId: string): Observable<void> {
        let url_ = this.baseUrl + "/hub/search/redirects/store/{storeId}/{ruleId}";
        if (storeId === undefined || storeId === null)
            throw new globalThis.Error("The parameter 'storeId' must be defined.");
        url_ = url_.replace("{storeId}", encodeURIComponent("" + storeId));
        if (ruleId === undefined || ruleId === null)
            throw new globalThis.Error("The parameter 'ruleId' must be defined.");
        url_ = url_.replace("{ruleId}", encodeURIComponent("" + ruleId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("No autorizado / Token inv\u00e1lido", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export class RedirectsPageDto implements IRedirectsPageDto {
    /** Metadatos de la página */
    page!: any;
    /** Lista de reglas de redirección */
    items!: RedirectsDto[];

    [key: string]: any;

    constructor(data?: IRedirectsPageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.items = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.page = _data["page"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(RedirectsDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RedirectsPageDto {
        data = typeof data === 'object' ? data : {};
        let result = new RedirectsPageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["page"] = this.page;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IRedirectsPageDto {
    /** Metadatos de la página */
    page: any;
    /** Lista de reglas de redirección */
    items: RedirectsDto[];

    [key: string]: any;
}

export class CreateRedirectRuleDto implements ICreateRedirectRuleDto {
    /** Nombre descriptivo de la regla de redirección */
    name!: string;
    /** URL interna de destino para la redirección. Debe comenzar con "/". No puede contener dominio ni protocolo (http/https). */
    redirectUrl!: string;
    /** Conjunto de reglas de trigger para activar la redirección. Todas las condiciones deben usar el mismo operador lógico (AND o OR). */
    triggerRules!: TriggerRulesDto;
    /** Estado actual de la regla */
    status!: CreateRedirectRuleDtoStatus;

    [key: string]: any;

    constructor(data?: ICreateRedirectRuleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.triggerRules = new TriggerRulesDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.name = _data["name"];
            this.redirectUrl = _data["redirectUrl"];
            this.triggerRules = _data["triggerRules"] ? TriggerRulesDto.fromJS(_data["triggerRules"]) : new TriggerRulesDto();
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): CreateRedirectRuleDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateRedirectRuleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["name"] = this.name;
        data["redirectUrl"] = this.redirectUrl;
        data["triggerRules"] = this.triggerRules ? this.triggerRules.toJSON() : undefined as any;
        data["status"] = this.status;
        return data;
    }
}

export interface ICreateRedirectRuleDto {
    /** Nombre descriptivo de la regla de redirección */
    name: string;
    /** URL interna de destino para la redirección. Debe comenzar con "/". No puede contener dominio ni protocolo (http/https). */
    redirectUrl: string;
    /** Conjunto de reglas de trigger para activar la redirección. Todas las condiciones deben usar el mismo operador lógico (AND o OR). */
    triggerRules: TriggerRulesDto;
    /** Estado actual de la regla */
    status: CreateRedirectRuleDtoStatus;

    [key: string]: any;
}

export class RedirectsDto implements IRedirectsDto {
    /** ID de la regla */
    id!: string;
    /** Nombre de la regla de redirección */
    name!: string;
    /** URL de destino para la redirección. Debe comenzar con / y no contener dominio. */
    redirectUrl!: string;
    /** Reglas para activar la redirección */
    triggerRules!: TriggerRulesDto;
    /** Estado de la regla (ACTIVA / INACTIVA) */
    status!: RedirectsDtoStatus;

    [key: string]: any;

    constructor(data?: IRedirectsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.triggerRules = new TriggerRulesDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.id = _data["id"];
            this.name = _data["name"];
            this.redirectUrl = _data["redirectUrl"];
            this.triggerRules = _data["triggerRules"] ? TriggerRulesDto.fromJS(_data["triggerRules"]) : new TriggerRulesDto();
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): RedirectsDto {
        data = typeof data === 'object' ? data : {};
        let result = new RedirectsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["id"] = this.id;
        data["name"] = this.name;
        data["redirectUrl"] = this.redirectUrl;
        data["triggerRules"] = this.triggerRules ? this.triggerRules.toJSON() : undefined as any;
        data["status"] = this.status;
        return data;
    }
}

export interface IRedirectsDto {
    /** ID de la regla */
    id: string;
    /** Nombre de la regla de redirección */
    name: string;
    /** URL de destino para la redirección. Debe comenzar con / y no contener dominio. */
    redirectUrl: string;
    /** Reglas para activar la redirección */
    triggerRules: TriggerRulesDto;
    /** Estado de la regla (ACTIVA / INACTIVA) */
    status: RedirectsDtoStatus;

    [key: string]: any;
}

export class UpdateRedirectsDto implements IUpdateRedirectsDto {
    /** Nombre descriptivo de la regla de redirección */
    name?: string;
    /** URL interna de destino para la redirección. Debe comenzar con "/". No puede contener dominio ni protocolo (http/https). */
    redirectUrl?: string;
    /** Conjunto de reglas de trigger para activar la redirección. Todas las condiciones deben usar el mismo operador lógico (AND o OR). */
    triggerRules?: TriggerRulesDto;
    /** Estado actual de la regla */
    status?: UpdateRedirectsDtoStatus;

    [key: string]: any;

    constructor(data?: IUpdateRedirectsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.name = _data["name"];
            this.redirectUrl = _data["redirectUrl"];
            this.triggerRules = _data["triggerRules"] ? TriggerRulesDto.fromJS(_data["triggerRules"]) : undefined as any;
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): UpdateRedirectsDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateRedirectsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["name"] = this.name;
        data["redirectUrl"] = this.redirectUrl;
        data["triggerRules"] = this.triggerRules ? this.triggerRules.toJSON() : undefined as any;
        data["status"] = this.status;
        return data;
    }
}

export interface IUpdateRedirectsDto {
    /** Nombre descriptivo de la regla de redirección */
    name?: string;
    /** URL interna de destino para la redirección. Debe comenzar con "/". No puede contener dominio ni protocolo (http/https). */
    redirectUrl?: string;
    /** Conjunto de reglas de trigger para activar la redirección. Todas las condiciones deben usar el mismo operador lógico (AND o OR). */
    triggerRules?: TriggerRulesDto;
    /** Estado actual de la regla */
    status?: UpdateRedirectsDtoStatus;

    [key: string]: any;
}

export class TriggerRulesDto implements ITriggerRulesDto {
    /** Operador lógico del bloque */
    logicalOperator!: TriggerRulesDtoLogicalOperator;
    /** Lista de condiciones */
    conditions!: TriggerConditionDto[];

    [key: string]: any;

    constructor(data?: ITriggerRulesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.conditions = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.logicalOperator = _data["logicalOperator"];
            if (Array.isArray(_data["conditions"])) {
                this.conditions = [] as any;
                for (let item of _data["conditions"])
                    this.conditions!.push(TriggerConditionDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TriggerRulesDto {
        data = typeof data === 'object' ? data : {};
        let result = new TriggerRulesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["logicalOperator"] = this.logicalOperator;
        if (Array.isArray(this.conditions)) {
            data["conditions"] = [];
            for (let item of this.conditions)
                data["conditions"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ITriggerRulesDto {
    /** Operador lógico del bloque */
    logicalOperator: TriggerRulesDtoLogicalOperator;
    /** Lista de condiciones */
    conditions: TriggerConditionDto[];

    [key: string]: any;
}

export class TriggerConditionDto implements ITriggerConditionDto {
    /** Término a evaluar */
    term!: string;
    /** Operador de coincidencia */
    operator!: TriggerConditionDtoOperator;

    [key: string]: any;

    constructor(data?: ITriggerConditionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.term = _data["term"];
            this.operator = _data["operator"];
        }
    }

    static fromJS(data: any): TriggerConditionDto {
        data = typeof data === 'object' ? data : {};
        let result = new TriggerConditionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["term"] = this.term;
        data["operator"] = this.operator;
        return data;
    }
}

export interface ITriggerConditionDto {
    /** Término a evaluar */
    term: string;
    /** Operador de coincidencia */
    operator: TriggerConditionDtoOperator;

    [key: string]: any;
}

export enum Status {
    ACTIVE = "ACTIVE",
    INACTIVE = "INACTIVE",
}

export enum CreateRedirectRuleDtoStatus {
    ACTIVE = "ACTIVE",
    INACTIVE = "INACTIVE",
}

export enum RedirectsDtoStatus {
    ACTIVE = "ACTIVE",
    INACTIVE = "INACTIVE",
}

export enum UpdateRedirectsDtoStatus {
    ACTIVE = "ACTIVE",
    INACTIVE = "INACTIVE",
}

export enum TriggerRulesDtoLogicalOperator {
    AND = "AND",
    OR = "OR",
}

export enum TriggerConditionDtoOperator {
    IS = "IS",
    CONTAINS = "CONTAINS",
}

export class ApiException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if (result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new ApiException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader();
            reader.onload = event => {
                observer.next((event.target as any).result);
                observer.complete();
            };
            reader.readAsText(blob);
        }
    });
}